'use client';
var classes = {"logo":"m-2075ec07","mantineUILogo":"m-36ceca49"};

export { classes as default };
//# sourceMappingURL=MantineLogo.module.css.mjs.map
